import { useEffect, useState } from 'react';
import { IExercise } from '../models/exercise';

export const useExerciseHook = (initialPage: number) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isOpenPrint, setIsOpenPrint] = useState<boolean>(false);

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [initialPage]);

  const scrollToBottom = async (exerciseChangeFunction: any) => {
    await exerciseChangeFunction;

    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  const goToNextExercise = (
    totalExercises: number,
    onPageChange: (page: number) => void
  ) => {
    const nextPage = currentPage === totalExercises - 1 ? 0 : currentPage + 1;

    setCurrentPage(nextPage);
    onPageChange(nextPage);
  };

  const goToPreviousExercise = (
    totalExercises: number,
    onPageChange: (page: number) => void
  ) => {
    const previousPage =
      currentPage === 0 ? totalExercises - 1 : currentPage - 1;

    setCurrentPage(previousPage);
    onPageChange(previousPage);
  };

  const goToExercise = (selectedExercise: number) => {
    setCurrentPage(selectedExercise);
  };

  const checkExercise = (exercise: IExercise) => {
    let hasWrongAlternative = false;

    exercise.done = true;
    exercise.alternatives = exercise!.alternatives.map((alternative) => {
      if (alternative.selected) {
        if (alternative.correct) {
          alternative.status = 'success';
        } else {
          alternative.status = 'error';
          hasWrongAlternative = true;
        }
      } else {
        if (
          exercise.exerciseType === 'multiple_answer' &&
          alternative.correct
        ) {
          hasWrongAlternative = true;
        }
      }

      return alternative;
    });

    exercise.correct = !hasWrongAlternative;

    return exercise;
  };

  return {
    currentPage,
    isOpenPrint,
    goToExercise,
    goToPreviousExercise,
    goToNextExercise,
    checkExercise,
    scrollToBottom,
    setIsOpenPrint,
  };
};
